import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { doOpenTicketChangesetPage } from 'actions/pages'
import { IconButton } from 'shared/ui'
import { humanFileSize } from 'util/strings'
import { strftime } from 'util/date'
import { fixDownloadUrl } from 'util/url'

import Tooltip from '@groovehq/internal-design-system/lib/components/Tooltip/Tooltip'
import FileIcon from './FileIcon'
import { styles } from './styles'

export default function Attachment({
  attachment,
  ticketId,
  subdomain,
  isImage,
  onClick: onAttachmentClick,
}) {
  const dispatch = useDispatch()

  const onOpen = useCallback(
    () => {
      const isChangesetInCurrentTicket = ticketId === attachment.ticketId

      if (isChangesetInCurrentTicket) {
        dispatch(doOpenTicketChangesetPage(ticketId, attachment.changesetId))
        return
      }

      window.open(
        `/tickets/${attachment.ticketId}/${attachment.changesetId}`,
        '_blank'
      )
    },
    [dispatch, ticketId, attachment]
  )

  const onClick = useCallback(
    () => {
      if (!isImage) {
        return
      }

      onAttachmentClick(attachment.id)
    },
    [onAttachmentClick, attachment, isImage]
  )

  return (
    <div css={styles.attachment}>
      <div css={styles.content}>
        <FileIcon
          fileType={attachment.fileType}
          fileName={attachment.fileName}
          url={attachment.url}
          onClick={onClick}
        />

        <div css={styles.textContent}>
          <div className="grui w-100 flex items-center">
            <span
              css={[styles.fileName, isImage ? styles.imageFileName : null]}
              onClick={onClick}
            >
              <Tooltip
                title={attachment.fileName}
                position="top"
                strategy="fixed"
              >
                <span>{attachment.fileName}</span>
              </Tooltip>
            </span>
            <span css={styles.fileSize}>
              ({humanFileSize(attachment.fileSize)})
            </span>
          </div>
          <div className="grui w-100 flex items-center" css={styles.dateText}>
            {attachment.creator && `${attachment.creator.name} - `}
            {strftime('%d %b %Y', attachment.createdAt)}
          </div>
        </div>
      </div>

      <div className="grui hidden attachment-icon-buttons">
        <IconButton
          name="downloadAlt"
          svg
          size="tiny"
          iconSize={14}
          tooltip="Download"
          as="a"
          target="_blank"
          href={fixDownloadUrl(attachment.downloadUrl, subdomain)}
          download={attachment.fileName}
        />

        <IconButton
          name="externalLink"
          svg
          onClick={onOpen}
          size="tiny"
          iconSize={14}
          tooltip="Open message"
        />
      </div>
    </div>
  )
}
